import React, { useState } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import "./AddStudent.css";
import {url,localUrl} from '../../BaseUrl';

function AddStudent() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [monthlyFees, setMonthlyFees] = useState(100);
  const [courseName, setCourseName] = useState("");
  const [feeReminderDate, setFeeReminderDate] = useState("");
  const [gender, setGender] = useState("");
  const [password, setPassword] = useState("");  // Added password state

  const mutation = useMutation({
    mutationFn: async (studentData) => {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${url}/api/auth/AddStudent`,
        studentData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      alert("Student added successfully!");
      // Reset fields after successful submission
      resetFields();
    },
    onError: (error) => {
      console.error("Error adding student:", error);
      alert("Failed to add student. Please try again.");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation for phone number length (assuming it should be 10 digits)
    if (!/^\d{10}$/.test(phone)) {
      alert("Phone number must be 10 digits.");
      return;
    }

    // Validation for password length
    if (password.length < 6) {
      alert("Password must be at least 6 characters long.");
      return;
    }

    const studentData = {
      firstName,
      lastName,
      email,
      phone,
      courseName,
      feeReminderDate,
      gender,
      totalFees: parseFloat(monthlyFees),
      password,  // Add password to the student data
    };

    mutation.mutate(studentData);
  };

  const resetFields = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setCourseName("");
    setFeeReminderDate("");
    setGender("");
    setMonthlyFees(100);
    setPassword("");  // Reset the password field
  };

  return (
    <div>
      <h2>Add Student</h2>
      <form onSubmit={handleSubmit}>
        <label>
          First Name:
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </label>
        <label>
          Last Name:
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </label>
        <label>
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          Phone Number:
          <input
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </label>
        <label>
          Course Name:
          <input
            type="text"
            value={courseName}
            onChange={(e) => setCourseName(e.target.value)}
            required
          />
        </label>
        <label>
          Fee Reminder Date:
          <input
            type="date"
            value={feeReminderDate}
            onChange={(e) => setFeeReminderDate(e.target.value)}
            required
          />
        </label>
        <label>
          Gender:
          <select
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </label>
        <label>
          Monthly Fees:
          <input
            type="number"
            value={monthlyFees}
            onChange={(e) => setMonthlyFees(e.target.value)}
            required
          />
        </label>
        <label>
          Student Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        
        <button type="submit" disabled={mutation.isLoading}>
          {mutation.isLoading ? "Adding..." : "Register Student"}
        </button>
        {mutation.isError && <p style={{ color: 'red' }}>Error adding student!</p>}
      </form>
    </div>
  );
}

export default AddStudent;
